import HomeAutomationLayout from "./HomeAutomationLayout";
import HomeAutomationPage from "./pages/HomeAutomationPage.vue"
import HomeAutomationAppointmentDashboardPage from "./pages/HomeAutomationAppointmentPage.vue";

export const homeAutomationRoutes = {
  path: "home-automation",
  // name: "HomeAutomation",
  component: HomeAutomationLayout,
  children: [
    {
      name: "HomeAutomationPage",
      path: "dashboard",
      component: HomeAutomationPage,
    },
    {
      name: "HomeAutomationAppointmentDashboardPage",
      path: "appointment",
      component: HomeAutomationAppointmentDashboardPage,
    },
  ]
};



// WEBPACK FOOTER //
// ./src/features/home-automation/routes.js